import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StoreService } from 'src/app/core/store/store.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { SearchService } from 'src/app/shared/services/search.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'exclusive-header-search',
  templateUrl: './exclusive-header-search.component.html',
  styleUrls: ['./exclusive-header-search.component.scss']
})
export class ExclusiveHeaderSearchComponent implements OnInit {

    products = [];
    searchTerm = '';
    cat = 'creative';
    suggestions = [];
    timer: any;
    SERVER_URL = environment.SERVER_URL;
    currentUser = null;
    public licenseType : boolean = true;
    public isSearchFocused: boolean = false;
      
  constructor(public activeRoute: ActivatedRoute,
            public router: Router,
            public utilsService: UtilsService, 
            public apiService: ApiService, 
            public searchService: SearchService,
            public storageService: StoreService) {

      }

  ngOnInit(): void {
        this.searchService = SearchService.getInstance();
        this.searchService.search.subscribe(searchText => {
            this.searchTerm = searchText;
        });
        this.searchService.category.subscribe(category => {
            this.cat = category;
        });
        document.querySelector('body').addEventListener('click', this.closeSearchForm);

        this.getCurrentUrl();
    }

    getCurrentUrl(){
      this.currentUser = this.storageService.getItem('currentUser');
    }

    ngOnDestroy(): void {
        document.querySelector('body').removeEventListener('click', this.closeSearchForm);
    }

    searchProducts(event: any) {
        this.searchTerm = event.target.value;
        this.fetchProducts();
    }

    fetchProducts() {
        if (this.searchTerm.length > 2) {
            if (this.timer) {
                window.clearTimeout(this.timer);
            }

            this.timer = setTimeout(() => {
                this.apiService.getSearchHint(this.searchTerm).subscribe(result => {
                    this.suggestions = result.hints;
                });
            }, 500);
        } else {
            window.clearTimeout(this.timer);
            this.suggestions = [];
        }
    }

    matchEmphasize(name: string) {
        var regExp = new RegExp(this.searchTerm, 'i');
        return name.replace(
            regExp,
            match => '<strong>' + match + '</strong>'
        );
    }

    goProductPage() {
        // this.searchTerm = '';
        this.suggestions = [];
        // var inputElement: any = document.querySelector('.header-search .form-control');
        // inputElement.value = '';
        this.closeSearchForm();
    }

    onSearchToggle(e: Event) {
        e.stopPropagation();
        document
            .querySelector('.header .search-toggle')
            .classList.toggle('active');
        document
            .querySelector('.header .header-search-wrapper')
            .classList.toggle('show');
    }

    showSearchForm(e: Event) {
        document
            .querySelector('.search-bar .header-search')
            .classList.add('show');
        e.stopPropagation();
    }

    closeSearchForm() {
        document
            .querySelector('.search-bar .header-search')
            .classList.remove('show');
    }

    submitSearchForm(e: Event) {
        e.preventDefault();
        this.goProductPage();
        this.navigateToSearchPage(this.searchTerm);
        // let type = 'images';
        // if (this.cat == 'creative-videos' || this.cat == 'editorial-videos') {
        //     type = 'videos';
        // }
        // this.searchService.setSearch(this.searchTerm);
        // this.searchService.setCategory(this.cat);
        // const url = this.router.url.split('?')[0]
        //
        // if ((url == '/product/search/images' && type == 'images') ||
        //     (url == '/product/search/videos' && type == 'videos')) {
        //
        //     this.router.navigate([], {
        //         queryParams: {searchText: this.searchTerm, category: this.cat, page: 1},
        //         queryParamsHandling: 'merge'
        //     });
        //
        // } else {
        //     this.router.navigate(['/product/search/' + type],
        //         {queryParams: {searchText: this.searchTerm, category: this.cat}});
        // }
    }

    onCatSelect(event: any) {
        this.cat = event.currentTarget.value;
        // this.fetchProducts();
        this.searchService.setSearch(this.searchTerm);
        this.searchService.setCategory(this.cat);
    }

    selectSearch(e: Event, suggestion: any) {
        e.preventDefault();
        this.searchTerm = suggestion;
        // let type = 'images';
        // if (this.cat == 'creative-videos' || this.cat == 'editorial-videos') {
        //     type = 'videos';
        // }
        // this.searchService.setCategory(this.cat);
        // this.router.navigate(['/product/search/' + type], {queryParams: {searchText: suggestion, category: this.cat}});
        this.navigateToSearchPage(suggestion);


    }

    navigateToSearchPage(keyword)
    {
        let type = 'images';
        if (this.cat == 'creative-videos' || this.cat == 'editorial-videos') {
            type = 'videos';
        }
        this.searchService.setSearch(keyword);
        this.searchService.setCategory(this.cat);

        const url = this.router.url.split('?')[0]

        if ((url == '/product/search/images' && type == 'images') ||
            (url == '/product/search/videos' && type == 'videos')) {

            this.router.navigate([], {
                queryParams: {searchText: keyword, category: this.cat, page: 1},
                queryParamsHandling: 'merge'
            });

        } else {
            this.router.navigate(['/product/search/' + type],
                {queryParams: {searchText: keyword, category: this.cat}});
        }
    }

}
